var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrongsign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1669",
    "data-name": "Group 1669",
    transform: "translate(-1121 -321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1655",
    "data-name": "Group 1655",
    transform: "translate(3 72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1886",
    "data-name": "Path 1886",
    d: "M8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0Z",
    transform: "translate(1118 249)",
    fill: "#575b64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Component_59_20",
    "data-name": "Component 59 \\u2013 20",
    transform: "translate(1128.657 323) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11413",
    "data-name": "Group 11413",
    transform: "translate(0.335 0.336)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11964",
    "data-name": "Path 11964",
    d: "M-1676.151,16256h7.328",
    transform: "translate(1676.151 -16252.336)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11965",
    "data-name": "Path 11965",
    d: "M0,0H7.328",
    transform: "translate(3.664) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3684",
    "data-name": "Rectangle 3684",
    width: 8,
    height: 8,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrongsign);
export default __webpack_public_path__ + "static/media/wrongsign.1202c1d4e8b2fdeaa8374123bb44a3c7.svg";
export { ForwardRef as ReactComponent };